// extracted by mini-css-extract-plugin
export default {"component":"z7PCw"};